import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { getCookies, removeCookies } from '../services/Utility'
import Select from 'react-select';
import _ from 'lodash'
import Api from '../services/Api';

export default function Navbar({ project }) {
    const [projects, setProjects] = useState([]);
    const [allProjects, setAllProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);

    useEffect(() => {
        getProjects();
    }, [])

    const getProjects = async () => {
        const response = await Api.getTableData('projects');

        if (getCookies("isAdmin") === 'tenant') {
            const projects = response.data.data.results.map(item => {
                const obj = {
                    value: item.id,
                    label: item.name
                }
                return obj;
            });

            setAllProjects(projects);
            setProjects(projects);

            if (localStorage.getItem('DP_PROJECT_ID') === null || localStorage.getItem('DP_PROJECT_ID') === undefined) {                
                const selectedProject = projects[0];
                setSelectedProject(selectedProject)
                localStorage.setItem('DP_PROJECT_ID', selectedProject.value);
                window.location.reload();
            }
        }
        else {
            let projects = [{
                value: 0,
                label: 'All Projects'
            }];

            projects = projects.concat(response.data.data.results.map(item => {
                const obj = {
                    value: item.id,
                    label: item.name
                }
                return obj;
            }))

            setAllProjects(response.data.data.results);
            setProjects(projects);
        }
    }

    const setLocalProject = (project) => {
        if (project.value === 0) {
            localStorage.removeItem('DP_PROJECT_ID');
        }
        else {
            const selectedProject = _.find(allProjects, { id: project.value });
            setSelectedProject(selectedProject)
            localStorage.setItem('DP_PROJECT_ID', project.value);
        }

        window.location.reload();
        // window.location.pathname = '/dashboard/DataSubjectTypes';
    }

    const logout = () => {
        localStorage.removeItem('DP_PROJECT_ID');
        removeCookies("auth-token")
        removeCookies("tenant-id")
        removeCookies("isAdmin")
        window.location.pathname = '/';
    }

    return (
        <nav className="bg-zinc-900">
            <div className="mx-auto max-w-8xl px-2 sm:px-6 lg:px-8">
                <div className="relative flex h-16 items-center justify-between">
                    <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                        <div className="flex flex-shrink-0 items-center">
                            <img className="block h-8 w-auto lg:hidden" src="/images/R2Logo.png" alt="R2 Consulting" />
                            <img className="hidden h-8 w-auto lg:block" src="/images/R2CLogo.png" alt="R2 Consulting" />
                        </div>
                    </div>
                    <div className="hidden sm:ml-6 sm:block">
                        <div className="flex space-x-4">
                            {
                                getCookies("auth-token") ? <Select
                                    className="select-dd"
                                    options={projects}
                                    onChange={(value, item) => setLocalProject(value)}
                                    value={projects.filter(p => p.value == localStorage.getItem('DP_PROJECT_ID'))}
                                /> : null
                            }
                            {getCookies("auth-token") ? <button className="bg-gray-900 text-white px-3 py-2 rounded-md text-sm font-medium" onClick={logout}>
                                Logout
                            </button> :
                                <Link to="/login" className="bg-gray-900 text-white px-3 py-2 rounded-md text-sm font-medium" aria-current="page">
                                    Corporate Login
                                </Link>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="sm:hidden" id="mobile-menu">
                <div className="space-y-1 px-2 pt-2 pb-3">
                    <a href="#" className="bg-gray-900 text-white block px-3 py-2 rounded-md text-base font-medium" aria-current="page">Get Started</a>
                </div>
            </div>
        </nav>
    )
}
